import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { PageSectionTwoColumnsImageFullwidth } from 'components/page/sections/page-section-two-columns-image-fullwidth';
import { SectionContentLinkList } from 'components/section-content-link-list';
import { SectionContentLinkListIdEight } from 'components/section-content-link-list/section-content-link-list.enums';

export const TabEightContainer: React.FC = () => {
  const list = [
    {
      id: SectionContentLinkListIdEight.OurContactInformation,
      text: sections.tabEightSection.tab.contents.item1(),
    },
  ];
  const props = {
    columnLeft: {
      title: sections.tabEightSection.tab.title(),
      subTitle: sections.tabEightSection.tab.text(),
    },
    columnRight: {
      title: sections.tabEightSection.tab.contents.title(),
      content: <SectionContentLinkList list={list} />,
    },
    image: {
      src: `${CdnImagePath}/assets/tab-08/tab-08-01.jpg`,
      objectPosition: '50% 33%',
      inlinePosition: 'start',
    },
  };

  return <PageSectionTwoColumnsImageFullwidth {...props} />;
};
